import React, { useEffect, useState, useCallback } from 'react';
import {
    canSeePurchasingNotifications,
    fetchPurchasingNotifications,
    PURCHASING_NOTIFICATIONS_CHANGED,
} from '../services/purchasingNotificationsService';
import { NumberFormat } from '../functions/generalFunctions';
import { pricesFormat } from '../functions/pricesFormat';

// PURCHNOTIF-2026-10-31 — card del Dashboard: items con aviso de cambio de costo aún pendiente.
const styles = {
    card: { borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' },
    header: { background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' },
    title: { color: 'white', fontWeight: 700, fontSize: '0.8125rem' },
    th: { fontSize: '0.72rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.06em' },
};

export const PendingCostReviewCard = () => {
    const [pending, setPending] = useState([]);
    const [error, setError] = useState('');

    const load = useCallback(async () => {
        try {
            const data = await fetchPurchasingNotifications();
            setPending(data.pending || []);
            setError('');
        } catch (err) {
            setError(err.message);
        }
    }, []);

    useEffect(() => {
        if (!canSeePurchasingNotifications()) return undefined;
        load();
        window.addEventListener(PURCHASING_NOTIFICATIONS_CHANGED, load);
        return () => window.removeEventListener(PURCHASING_NOTIFICATIONS_CHANGED, load);
    }, [load]);

    // Sin pendientes (o si falló la carga) la card no se muestra.
    if (!canSeePurchasingNotifications() || pending.length === 0) return null;

    const money = (value) => '$' + NumberFormat(pricesFormat(value));

    return (
        <div className="card mt-3 mb-3" style={styles.card}>
            <div style={styles.header}>
                <span style={styles.title}>Items with pending cost/price review ({pending.length})</span>
            </div>
            <div className="card-body p-0">
                {error ? (
                    <p className="text-danger m-3">{error}</p>
                ) : (
                    <div className="table-responsive" style={{ maxHeight: 320 }}>
                        <table className="table table-sm table-hover mb-0 align-middle">
                            <thead className="table-light" style={{ position: 'sticky', top: 0 }}>
                                <tr>
                                    <th style={styles.th}>Purchase Order</th>
                                    <th style={styles.th}>Date</th>
                                    <th style={styles.th}>Item Code</th>
                                    <th style={styles.th} className="text-end">Cost</th>
                                    <th style={styles.th} className="text-end">New Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pending.map((n) => (
                                    <tr key={n.id}>
                                        <td>{n.purchase_order}</td>
                                        <td>{new Date(n.created_at).toLocaleDateString()}</td>
                                        <td className="fw-bold">{n.item_code}</td>
                                        <td className="text-end">{money(n.old_cost)}</td>
                                        <td className="text-end">{money(n.new_cost)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};
